<script>
import { mapState, mapActions } from "vuex";
export default {
  methods: {
    ...mapActions("menu", ["changeMenuOpened"])
  },
  computed: {
    ...mapState("menu", ["menuOpened"])
  }
};
</script>

<template>
  <div class="hamburguer">
    <input type="checkbox" :value="menuOpened" @change="changeMenuOpened(!menuOpened)">
    <span></span>
    <span></span>
    <span></span>
    <div></div>
  </div>
</template>

<style scoped>
.hamburguer {
  position: absolute;
  top: 22px;
  z-index: 1;
  user-select: none;
}

.hamburguer input {
  display: block;
  width: 40px;
  height: 32px;
  position: absolute;
  top: -7px;
  left: -5px;
  cursor: pointer;
  opacity: 0;
  z-index: 2;
  -webkit-touch-callout: none;
}

.hamburguer span {
  display: block;
  width: 33px;
  height: 4px;
  margin-bottom: 5px;
  position: relative;
  background: #fff;
  border-radius: 3px;
  z-index: 1;
  transform-origin: 4px 0px;
  transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
    background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease;
}

.hamburguer span:first-child {
  transform-origin: 0% 0%;
}

.hamburguer span:nth-last-child(2) {
  transform-origin: 0% 100%;
}

.hamburguer input:checked ~ span {
  opacity: 1;
  transform: rotate(45deg) translate(-2px, -1px);
  background: #fff;
}

.hamburguer input:checked ~ span:nth-last-child(3) {
  opacity: 0;
  transform: rotate(0deg) scale(0.2, 0.2);
}

.hamburguer input:checked ~ span:nth-last-child(2) {
  transform: rotate(-45deg) translate(0, -1px);
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar/Burguer.vue